import React from 'react'
import { TextInput, Typography } from '@telavita-core/react-design-kit'

import * as S from './styles'
import { Controller, useFormContext } from 'react-hook-form'
import { MedicalRecordFormData } from '../../medicalRecordSchema'

export function MedicalProfessionalReferral(): JSX.Element {
  const { control, watch } = useFormContext<MedicalRecordFormData>()
  const medicalProfessionalValue = watch('medical_professional_referral')

  return (
    <S.MedicalProfessionalReferralContainer>
      <Typography weight='bolder' variant='content2'>
        Encaminhamento a profissionais de saúde
      </Typography>

      <Typography variant='content3'>
        Adicione apenas se tiver recomendado um especialista ao paciente.
      </Typography>

      <S.InputWrapper>
        <Controller
          name='medical_professional_referral'
          control={control}
          render={({ field }) => (
            <TextInput
              {...field}
              placeholder='Digite'
              onInputChange={field.onChange}
              maxLength={100}
            />
          )}
        />
        <S.InputLegend>
          <Typography variant='content3' italic>
            Se houver mais de um, separe por vírgula.
          </Typography>

          <Typography variant='content3'>
            {medicalProfessionalValue?.length || 0}/100
          </Typography>
        </S.InputLegend>
      </S.InputWrapper>
    </S.MedicalProfessionalReferralContainer>
  )
}
